import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import about from "../image/about.webp";
import about1 from "../image/about1.webp";
import about2 from "../image/About2.webp";
import about3 from "../image/about3.webp";
import about4 from "../image/about4.webp";
import about5 from "../image/about5.webp";

class About extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="sec2">
              <div className="title">Hello, we’re Folksy</div>
              <p>
                Folksy is the home of British craft – and we think it’s the best
                place to buy and sell handmade in the UK. It’s run by us –
                James, Doug, Camilla, Clare, Kim, Mel, Dan and Jo – a small team
                based in Sheffield on the outskirts of the Peak District, who
                are passionate about craft.
              </p>
              <p>
                We’ve been spearheading the handmade movement in the British
                Isles since 2008 when we set up Folksy to offer artists,
                designers and makers a friendly place to sell their work. We’re
                now the largest UK marketplace for craft and handmade.
              </p>
              <p>
                Folksy is intentionally not curated, so there are no gatekeepers
                deciding who or what is “good enough” – everyone is welcome to
                sell on Folksy, whether they work in a professional studio or at
                their kitchen table, as long as their work is original or made
                by hand.
              </p>
              <div className="img">
                {" "}
                <img src={about} alt="" />
              </div>
              <p>
                Why do we ‘do’ Folksy? We mainly do it because we believe in:
              </p>
              <p>
                Craft skills. We love craft and design skills, the process by
                which people use their creativity and talent to make beautiful
                work. Most of all, we love making.
              </p>
              <p>
                Strength in numbers. Professional, portfolio and hobbyist
                designer-makers can reach a mainstream audience, test markets
                and grow their business more effectively on Folksy rather than
                through costly galleries and boutique shops.
              </p>
              <p>
                Cottage industries. Small scale production and handmade goods
                offer ways to be creative, manage resources effectively and
                support local economies.
              </p>
              <p>
                Meritocracy. Any designer-maker can list their work as long as
                it is hand crafted (no vintage or mass manufactured work is
                allowed). This creates a meritocracy where great work made at
                the kitchen table can rub shoulders with the best from
                established makers. The work should stand for itself.
              </p>
              <p>David not Goliath. :)</p>
              <div className="img">
                <img src={about1} alt="" />
              </div>
              <p>
                Folksy is run by James Boardwell and has been since it started
                in 2008. The inspiration for Folksy came from seeing the energy
                in the craft communities in the UK as well as North America and
                Australia in the early 2000s. At the same time the web was
                offering ways to crowd source solutions to problems and James,
                having worked in researching and designing digital services for
                the BBC decided to build a great place for people to showcase
                and sell their craft work.
              </p>
              <div className="img">
                <img src={about2} alt="" />
              </div>
              <p>
                Folksy launched in summer 2008, employed its first member of
                staff in 2009 and has since risen to become the most popular UK
                site for independently crafted and designed gifts and supplies
                with over £1 million in sales and a community of 13,000 or so
                designer makers and a bazillion* buyers.
              </p>
              <div className="img">
                <img src={about3} alt="" />
              </div>
              <p>
                We don’t have millions in VC funding. We’re not a hot start-up.
                But we do have the support of a wonderful community of British
                designers and makers who believe in the same things as us. Join
                them and open your own Folksy shop today or explore the wonders
                of the UK craft scene and buy from genuine artists and makers at
                Folksy.com – the UK’s biggest online craft fair!
              </p>
              <div className="img">
                <img src={about4} alt="" />
              </div>
              <p>
                (*OK, not a bazillion – how much is a bazillion anyway? – but a
                lot).
              </p>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default About;
